import styled from "styled-components";

export const AuthBackground = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;

  /* the faded background lives here */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("/assets/background.svg") no-repeat right bottom/50%;
    opacity: 0.2; /* only this layer is translucent */
    pointer-events: none; /* clicks go “through” */
    z-index: 0;
  }

  /* make sure all your real content floats above the pseudo-element */
  & > * {
    position: relative;
    z-index: 1;
  }
`;
